import React, { useMemo, useState } from 'react';
import { Text, TouchableOpacity, View, ViewStyle } from 'react-native';
import Popover, { PopoverPlacement } from 'react-native-popover-view';
import Icon from '../../Icon/Icon';
import { useTheme } from '../../../hooks/useTheme';
import { makeStyles } from './ActionLogs.styles';

export interface LogSelectOption {
  value: string;
  label: string;
}

interface Props {
  testID: string;
  options: LogSelectOption[];
  selectedValue: string;
  onValueChange: (value: string) => void;
  containerStyle?: ViewStyle;
}

const LogSelect: React.FC<Props> = ({
  testID,
  options,
  selectedValue,
  onValueChange,
  containerStyle,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { colors } = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);

  const selectedLabel =
    options.find(option => option.value === selectedValue)?.label ?? '';

  return (
    <Popover
      isVisible={isOpen}
      placement={PopoverPlacement.BOTTOM}
      onRequestClose={() => setIsOpen(false)}
      backgroundStyle={styles.selectBackdrop}
      popoverStyle={styles.selectPopover}
      from={
        <TouchableOpacity
          testID={testID}
          style={[styles.select, containerStyle]}
          onPress={() => setIsOpen(true)}
        >
          <Text style={styles.selectText} numberOfLines={1}>
            {selectedLabel}
          </Text>
          <Icon name="angle-down" size={20} color={colors.disclosure} />
        </TouchableOpacity>
      }
    >
      <View style={styles.selectOptions}>
        {options.map(option => (
          <TouchableOpacity
            key={option.value}
            testID={`${testID}-${option.value}`}
            style={styles.selectOption}
            onPress={() => {
              onValueChange(option.value);
              setIsOpen(false);
            }}
          >
            <Text
              style={[
                styles.selectOptionText,
                option.value === selectedValue && styles.selectOptionSelected,
              ]}
            >
              {option.label}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </Popover>
  );
};

export default LogSelect;
